import CartService from './CartService';

import apiService from '../ApiService';

export default new CartService(apiService);
